import useLogger from 'lib/util/useLogger'

const debug = useLogger('Parse claimables', 'cyan')

/**
 * Parse a claimable set (used for both claimed and claimable)
 *
 * @param {Array} items - the input items
 * @param {object} utilityConfig - the config from the app data
 * @param {boolean} isClaimed - whether is claimed
 * @returns {Array} the parsed result
 */
const parseClaimables = (items, utilityConfig, isClaimed = false) =>
  items.reduce((res, inputItem) => {
    const utilityId = inputItem?.utility?.toLowerCase()
    const match = utilityConfig?.[utilityId]

    if (!match) {
      debug.log("Couldn't match utility with ID:", utilityId)

      return res
    }

    const item = {
      ...inputItem,
      isClaimed,
      isClaimable: true,
      utilityId,
      permalinkId: inputItem?.[match.permalink_key],
      images: [
        inputItem.image,
        ...(Array.isArray(inputItem?.additional_images)
          ? inputItem?.additional_images
          : [])
      ],
      utilityProps: {
        utility_id: inputItem?.id,
        sub_level: inputItem?.utility
      },
      metadata: match
    }

    delete item.utility
    res.push(item)

    return res
  }, [])

/**
 * Parse the user claimables
 *
 * @param {object} props - the input props
 * @returns {object} the parsed claimables
 */
export default function parseUserClaimables (props) {
  const { claimable, claimed, utilityConfig } = props

  const claimableList = parseClaimables(claimable, utilityConfig)
  const claimedList = parseClaimables(claimed, utilityConfig, true)

  return {
    claimable: claimableList,
    claimed: claimedList,
    countClaimable: claimableList.length,
    countClaimed: claimedList.length
  }
}
